import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SelectedCompanyService {
  currentCompany$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  setCurrentCompany(companyId: string) {
    this.currentCompany$.next(companyId)
  }

  getCurrentCompany() {
    return this.currentCompany$.asObservable().pipe(
      filter(company => !!company)
    )
  }
}
